import { call, put, select, takeLatest } from 'redux-saga/effects';
import moment from 'moment';
import * as api from '../../api';
import * as actions from './actions';
import {
    REQUEST_DATE_FORMAT,
    EMPTY_VALUE,
    DATE_TIME_TIMEZONE_FORMAT
} from './constants';
import getProductId from '../../selectors/product';
import { getProductTeachers } from '../../containers/teacher-roll/actions';
import { getProductClassrooms } from '../../containers/class-roll/actions';

const requestDateFormat = givenDate => moment(givenDate, DATE_TIME_TIMEZONE_FORMAT).format(REQUEST_DATE_FORMAT);
const getRequestsData = (state) => {
    const productId = getProductId(state);
    const { currentDate, selectedClassroomId, selectedGroupId, selectedTeacherId } = state.downloadCertificates;
    const { startDate: oldStartDate, endDate: oldEndDate } = currentDate;

    const startDate = requestDateFormat(oldStartDate);
    const endDate = requestDateFormat(oldEndDate);

    const request = { productId, startDate, endDate };

    if (selectedTeacherId !== undefined && selectedTeacherId !== EMPTY_VALUE) {
        request.teacherUserProfileId = selectedTeacherId;
    }

    if (selectedClassroomId !== undefined && selectedClassroomId !== EMPTY_VALUE) {
        request.classroomId = selectedClassroomId;
    }

    if (selectedGroupId !== undefined && selectedGroupId !== EMPTY_VALUE) {
        request.groupId = selectedGroupId;
    }

    return request;
};

export function* downloadCertificatesSetup() {
    const productId = yield select(getProductId);
    yield put(getProductTeachers(productId));
    yield put(getProductClassrooms(productId));
    yield put(actions.getAcademicYear());
}

export function* downloadCertificatesSetupSaga() {
    yield takeLatest(actions.DOWNLOAD_CERTIFICATES_SETUP, downloadCertificatesSetup);
}
export function* downloadCertificates({ certificateType }) {
    const state = yield select();
    const request = getRequestsData(state);
    if (certificateType) {
        request.type = certificateType;
    }
    let response = {};
    response = yield call(api.downloadCertificates, { ...request });

    if (response.status === 201) {
        const downloadUrl = `${response.verb.url}/${response.data}`;
        yield put(actions.downloadCertificatesSuccess(downloadUrl, true));
    } else {
        yield put(actions.downloadCertificatesFailure(false));
    }
}

export function* downloadCertificatesSaga() {
    yield takeLatest(actions.DOWNLOAD_CERTIFICATES_REQUEST, downloadCertificates);
}

export function* setTeacher() {
    yield put(actions.getCertificatesSummary());
}

export function* setTeacherSaga() {
    yield takeLatest(actions.SET_TEACHER_ID, setTeacher);
}

export function* setClassroom() {
    const state = yield select();
    const { selectedClassroomId } = state.downloadCertificates;
    if (selectedClassroomId !== EMPTY_VALUE) {
        yield put(actions.getClassroomGroups());
    } else {
        yield put(actions.clearClassroomGroups());
    }

    yield put(actions.getCertificatesSummary());
}

export function* setClassroomSaga() {
    yield takeLatest(actions.SET_CLASSROOM_ID, setClassroom);
}

export function* setGroup() {
    yield put(actions.getCertificatesSummary());
}

export function* setGroupSaga() {
    yield takeLatest(actions.SET_GROUP_ID, setGroup);
}

export function* getClassroomGroups() {
    const state = yield select();
    const { selectedClassroomId } = state.downloadCertificates;

    const payload = yield call(api.getClassroomGroups, selectedClassroomId);
    if (payload.status === 200) {
        yield put(actions.getClassroomGroupsSuccess(payload));
    } else {
        yield put(actions.getClassroomGroupsFailure());
    }
}

export function* getClassroomGroupsSaga() {
    yield takeLatest(actions.GET_CLASSROOM_GROUPS_REQUEST, getClassroomGroups);
}

export function* getAcademicYear() {
    const payload = yield call(api.getAcademicYear);
    if (payload.status === 200) {
        yield put(actions.getAcademicYearSuccess(payload));
    } else {
        yield put(actions.getAcademicYearFailure());
    }
}

export function* getAcademicYearSaga() {
    yield takeLatest(actions.GET_ACADEMIC_YEAR_REQUEST, getAcademicYear);
}

export function* getCertificatesSummary() {
    const state = yield select();
    const request = getRequestsData(state);

    const payload = yield call(api.getCertificatesSummary, request);

    if (payload.status === 200) {
        yield put(actions.getCertificatesSummarySuccess(payload));
    } else {
        yield put(actions.getCertificatesSummaryFailure());
    }
}

export function* getCertificatesSummarySaga() {
    yield takeLatest(actions.GET_ACADEMIC_YEAR_SUCCESS, getCertificatesSummary);
    yield takeLatest(actions.GET_CERTIFICATES_SUMMARY_REQUEST, getCertificatesSummary);
}

export function* onDatePickerChange() {
    yield put(actions.getCertificatesSummary());
}

export function* onDatePickerChangeSaga() {
    yield takeLatest(actions.ON_DATE_PICKER_CHANGE, onDatePickerChange);
}



// WEBPACK FOOTER //
// ./app/containers/download-certificates/saga.js